<template>
  <div class="container-fluid mt-1">
    <div class="row tab-holder brdrad shdw" v-if="!noData">
      <table class="table table-list border">
        <thead class="ubuntu-medium" style="background-color: #808080">
          <tr>
            <th scope="col">Name</th>
            <th scope="col">Device Id</th>
            <th scope="col" class="dropdown">Device Type</th>
            <th scope="col" class="dropdown">Gas Sensor</th>
            <th scope="col">Last Online</th>
            <th scope="col" v-if="roleId == 3">
              <i class="fas fa-edit"></i>
            </th>
            <th
              scope="col"
              v-if="roleId == 3 && email === 'abhilash_mishra@getambee.com'"
            >
              <i class="fas fa-history"></i>
            </th>
            <th
              scope="col"
              v-if="roleId == 3 && email === 'abhilash_mishra@getambee.com'"
            >
              <i class="fas fa-trash-alt"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="device in devices"
            v-bind:key="device._id"
            class="ubuntu-medium"
          >
            <td>
              <p class="name p-0">
                <a :href="'#/device/' + device.devId + '/info'" target="_blank">
                  <span
                    class="cursor-pointer"
                    data-toggle="tooltip"
                    title="Click for details"
                    >{{ device.name }}</span
                  >
                </a>
              </p>
            </td>
            <td>
              <p class="p-0">
                <a :href="'#/device/' + device.devId + '/info'" target="_blank">
                  <span
                    class="devId cursor-pointer"
                    data-toggle="tooltip"
                    title="Click for details"
                    >{{ device.devId }}</span
                  >
                </a>
              </p>
            </td>
            <td>{{ device.deviceType }}</td>
            <td>{{ device.gasSensor }}</td>
            <td>{{ device.lastOnline }}</td>
            <td v-if="roleId == 3">
              <i
                @click="routeToUpdate(device)"
                class="fas fa-pen"
                style="cursor: pointer"
              ></i>
            </td>
                <td
              scope="col"
              title="Clear history"
              v-if="roleId == 3 && email === 'abhilash_mishra@getambee.com'"
            >
              <i
                class="fas fa-history"
                @click="swalDeleteHistory(device.devId)"
              >
              </i>
            </td>
            <td
              scope="col"
              title="Delete device"
              v-if="roleId == 3 && email === 'abhilash_mishra@getambee.com'"
            >
              <i
                class="fas fa-trash-alt"
                @click="swalDeleteDevice(device.devId)"
              >
              </i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      class="modal fade bd-example-modal-lg"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
    >
      <div class="modal-dialog modal-sm">
        <div class="modal-content" style="width: 48px">
          <span class="fa fa-spinner fa-spin fa-3x"></span>
        </div>
      </div>
    </div>
    <div v-if="noData">No Matching Records Found.</div>
  </div>
</template>
<script>
import swtalrt from "../../mixins/swtalrt";
import Swal from "sweetalert2";
import { apiCall } from "@/utils/api";

export default {
  data() {
    return {
      roleId: parseInt(JSON.parse(localStorage.getItem("user")).roleId),
      email: JSON.parse(localStorage.getItem("user")).email,
      noData: false,
    };
  },
  props: ["devices"],
  methods: {
    routeToUpdate(id) {
      this.$router.push(`/updateDevice/${id.devId}`);
    },
    deleteDevice(id) {
      const deleteURI = `device/delete/${id}`;
      apiCall({ url: deleteURI, methods: "get" }).then((result) => {
        this.$emit("deviceDeleted", id);
      });
    },
    swalDeleteDevice(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteDevice(id);
          Swal.fire("Deleted!", "Device has been deleted.", "success");
        }
      });
    },
    swalDeleteHistory(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "The historical data for this device will be permanantly deleted!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.clearHistory(id);
          this.swalHistSuccess();
        }
      });
    },
    clearHistory(id) {
      const url = `reading/delete/${id}`;
      apiCall({ url: url, method: "delete" })
        .then((r) => {
          this.swalHistSuccess();
        })
        .catch((err) => {
          this.swalNetworkError();
        });
    },
  },
  mixins: [swtalrt],
  watch: {
    devices: {
      handler(v) {
        if (!v.length) {
          this.noData = true;
        } else this.noData = false;
      },
    },
  },
};
</script>

<style scoped>
.tab-holder {
  max-height: 60vh;
  overflow-y: auto;
}
th {
  color: white;
}
td .fa-trash-alt , td .fa-history {
  cursor: pointer;
}
</style>